import { useEffect, useState } from "react";
import LearnMore from "@/components/LearnMore";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/apiClient";
import Navbar from "@/components/Navbar";
import { ArrowRight } from "lucide-react";
import ImmersionInsights from "@/components/immersion/ImmersionInsights";

export default function Immersions() {
  const [topics, setTopics] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/topics").then((r) => setTopics(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-5xl mx-auto px-5 sm:px-8 py-10">
        <p className="text-xs uppercase tracking-[0.25em] text-primary mb-2">RLI · Immersion Journeys</p>
        <h1 className="font-serif text-4xl sm:text-5xl mb-3">What are you installing?</h1>
        <div className="mb-4"><LearnMore area="immersions" /></div>
        <p className="text-muted-foreground max-w-xl mb-10 leading-relaxed">Choose the identity you're stepping into. You'll pick your environment next — the affirmations, imagery and sound are shaped around your choice.</p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="topic-grid">
          {topics.map((t, i) => (
            <motion.button key={t.id} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              onClick={() => navigate(`/immersions/${t.id}`)} data-testid={`topic-card-${t.id}`}
              className="group text-left rounded-2xl border border-border p-6 hover:border-primary/40 hover:-translate-y-1 transition-all duration-300 bg-card/40">
              <div className="text-[10px] uppercase tracking-[0.18em] text-primary/70 mb-3">{t.category}</div>
              <div className="font-serif text-2xl leading-tight mb-1">{t.title}</div>
              <div className="text-sm text-muted-foreground mb-5">{t.subtitle}</div>
              <span className="text-sm text-primary flex items-center gap-1 opacity-70 group-hover:opacity-100">Choose environment <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" /></span>
            </motion.button>
          ))}
        </div>
        <div className="mt-12"><ImmersionInsights /></div>
      </main>
    </div>
  );
}
